import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { QUERY_KEYS } from '@/config/api'
import { axios } from '@/lib/axios'
import { handleApiError, MutationConfig, queryClient } from '@/lib/react-query'
import { useAppStore } from '@/stores/appStore'
import { Dto } from '@/types'

const signoutUser = (): Promise<void> => {
  return axios.post('/auth/signout')
}

export type UseSignoutUserOptions = {
  config?: MutationConfig<typeof signoutUser>
}

export const useSignoutUser = ({ config }: UseSignoutUserOptions = {}) => {
  const clearTokens = useAppStore((state) => state.actions.clearTokens)
  const clearSessionId = useAppStore((state) => state.actions.clearSessionId)

  return useMutation({
    ...config,
    mutationFn: signoutUser,
    onSuccess: async (data, vars, onRes, ctx) => {
      clearTokens()
      clearSessionId()
      queryClient.removeQueries({ queryKey: [QUERY_KEYS.getProfile] })
      config?.onSuccess?.(data, vars, onRes, ctx)
    },
    onError: (error: AxiosError<Dto['ExceptionDetails']>, vars, onRes, ctx) => {
      handleApiError(error)
      config?.onError?.(error, vars, onRes, ctx)
    },
  })
}
